module.exports = __webpack_public_path__ + "static/img/bkite21.c68f0f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/bkite21.jpg
// module id = 7RI3
// module chunks = 0